// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getOwnerInfoDisplayRecord(ownerInfo) {
  return {
          hd: {
            label: "Owner Mobile",
            value: {
              TAG: /* Text */0,
              _0: ownerInfo.ownerMobile
            }
          },
          tl: {
            hd: {
              label: "Owner Name",
              value: {
                TAG: /* Text */0,
                _0: ownerInfo.ownerName
              }
            },
            tl: {
              hd: {
                label: "Bank Name",
                value: {
                  TAG: /* Text */0,
                  _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(ownerInfo.bankName)
                }
              },
              tl: {
                hd: {
                  label: "Bank IFSC",
                  value: {
                    TAG: /* Text */0,
                    _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(ownerInfo.bankIfsc)
                  }
                },
                tl: {
                  hd: {
                    label: "Bank acc number",
                    value: {
                      TAG: /* Text */0,
                      _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(ownerInfo.bankAccountNumber)
                    }
                  },
                  tl: {
                    hd: {
                      label: "PAN",
                      value: {
                        TAG: /* Text */0,
                        _0: OptionTypeUtils$Catalyst.getStringFrmOptionalType(ownerInfo.pan)
                      }
                    },
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        };
}

function getView(driverInfo) {
  return React.createElement(CardComponent$Catalyst.make, {
              title: "Owner Info",
              className: "owner-info-container",
              children: React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                    loadableData: driverInfo,
                    children: (function (driverInfo) {
                        return CardRowViewMapper$Catalyst.CardRecordView.make("record", getOwnerInfoDisplayRecord(driverInfo.owner));
                      })
                  })
            });
}

export {
  getOwnerInfoDisplayRecord ,
  getView ,
  
}
/* react Not a pure module */
